var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComedy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Smiley-Lol--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Smiley Lol Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12A12 12 0 1 0 0.34 14.84a0.26 0.26 0 0 1 0 0.15A4.54 4.54 0 0 0 0 16.5a4 4 0 0 0 3.43 4 0.27 0.27 0 0 1 0.14 0.07 12 12 0 0 0 16.86 0 0.27 0.27 0 0 1 0.14 -0.07 4 4 0 0 0 3.43 -4 4.54 4.54 0 0 0 -0.33 -1.5 0.26 0.26 0 0 1 0 -0.15A12.07 12.07 0 0 0 24 12ZM2 16.5c0 -0.88 1.28 -2.91 1.79 -3.69a0.26 0.26 0 0 1 0.42 0C4.72 13.59 6 15.62 6 16.5a2 2 0 0 1 -4 0Zm14.56 -2a0.43 0.43 0 0 1 0.38 0.22 0.43 0.43 0 0 1 0 0.44 5.71 5.71 0 0 1 -9.88 0 0.43 0.43 0 0 1 0 -0.44 0.43 0.43 0 0 1 0.38 -0.22ZM7.29 7a3.19 3.19 0 0 1 2.94 2.14 1 1 0 0 1 -0.58 1.29 0.92 0.92 0 0 1 -0.36 0.07 1 1 0 0 1 -0.93 -0.64A1.22 1.22 0 0 0 7.29 9a1.2 1.2 0 0 0 -1.06 0.86 1 1 0 0 1 -1.3 0.57 1 1 0 0 1 -0.57 -1.29A3.18 3.18 0 0 1 7.29 7Zm6.48 2.14a3.08 3.08 0 0 1 5.87 0 1 1 0 0 1 -0.57 1.29 1 1 0 0 1 -1.3 -0.57A1.2 1.2 0 0 0 16.71 9a1.22 1.22 0 0 0 -1.07 0.86 1 1 0 0 1 -0.93 0.64 0.92 0.92 0 0 1 -0.36 -0.07 1 1 0 0 1 -0.58 -1.29ZM20 18.5a2 2 0 0 1 -2 -2c0 -0.88 1.28 -2.91 1.79 -3.69a0.26 0.26 0 0 1 0.42 0c0.51 0.78 1.79 2.81 1.79 3.69a2 2 0 0 1 -2 2Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComedy);
export default ForwardRef;